export default "__VITE_ASSET__Cp7E7ezn__"